import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompactCurrencyFilter from './PricingUtils';

class ProductPrice extends Component {
  constructor(props) {
    super(props);

    this.getPrice = this.getPrice.bind(this);
    this.priceRange = this.priceRange.bind(this);
    this.shouldShowMsrp = this.shouldShowMsrp.bind(this);
    this.priceTypeGetter = this.priceTypeGetter.bind(this);
    this.calcSaveAmount = this.calcSaveAmount.bind(this);

    this.state = {
      showPriceAndRefLabels: false,
      showPriceLabel: false,
      showRefLabel: false,
      showSaveAmount: false,
      showRefPrice: false,
    };
  }

  componentWillMount() {
    const { sku, isTile, hidePriceLabels } = this.props;
    const referencePrice = sku.reference_price;
    const price = this.getPrice();

    if (referencePrice && !(price === referencePrice.amount)) {
      const { type, amount } = referencePrice;

      this.setState({
        showRefPrice: true,
        refPrice: amount
      });

      if (!hidePriceLabels) {
        // Registry GRID Tiles or PDP MODAL
        if (isTile) {
          // TILE  state
          if (type === 'MSRP') {
            // TILE MSRP state
            this.setState({
              showRefLabel: true,
              refPriceLabel: 'List'
            });
          } else if (type === 'COMPAREATPRICE') {
            // TILE COMPAREATPRICE state
            this.setState({
              showPriceLabel: true,
              priceLabel: 'Sale'
            });
          }
        } else {
          this.setState({ showPriceAndRefLabels: true });
          if (type === 'MSRP') {
            // DETAIL MSRP state
            this.setState({
              priceLabel: 'Our Price',
              refPriceLabel: 'List',
              priceTip: '"Our Price" is the everyday value price for products Zola offers to our customers. "List" refers to the price at which the product is sold on the manufacturers\' website.'
            });
          } else if (type === 'COMPAREATPRICE') {
            // DETAIL COMPAREATPRICE state
            this.setState({
              priceLabel: 'On Sale',
              refPriceLabel: 'Regular',
              priceTip: '"On Sale" refers to the price we offer when a product has been temporarily marked down. "Regular" was our price before the product was marked down.',
              showSaveAmount: true
            });
          }
        }
      } else {
        // Registry LIST with Ref Price
        this.setState({
          showRefPrice: true
        });
      }
    }
  }

  getPrice() {
    return this.priceTypeGetter('price');
  }

  getMsrp() {
    return this.priceTypeGetter('msrp');
  }

  /**
   * Accepts a string and returns a numberic value
   * @param {String} str - string value that needs to be converted to number
   * @returns {Number} - number value the passed string is converted to
   */
  fromStringToNumber(str) {
    return Number(str.replace(/[$,]/g, ''));
  }

  priceTypeGetter(priceType) {
    const { sku, look, showRemaining } = this.props;
    if (sku && sku.contributions && sku.contributions.still_needs && showRemaining) {
      return this.fromStringToNumber(sku.contributions.still_needs);
    }
    return sku ? sku[priceType] : look[priceType];
  }

  shouldShowMsrp() {
    const { sku, look } = this.props;
    if (sku) {
      return sku.msrp && sku.price < sku.msrp;
    }
    return look.msrp && look.price.max < look.msrp.max;
  }

  priceRange(price) {
    let priceRange;
    if (typeof price === 'number') {
      priceRange = CompactCurrencyFilter(price);
    } else if (price.min === price.max) {
      priceRange = CompactCurrencyFilter(price.max);
    } else {
      priceRange = `${CompactCurrencyFilter(price.min)} - ${CompactCurrencyFilter(price.max)}`;
    }

    return priceRange;
  }

  calcSaveAmount() {
    const { sku } = this.props;
    const { amount } = sku.reference_price;
    return (amount - this.getPrice()).toFixed(2);
  }

  render() {
    const { isTile, showRemaining } = this.props;
    const { priceLabel, refPriceLabel, showPriceAndRefLabels, showPriceLabel, showRefPrice, showSaveAmount, showRefLabel, refPrice, priceTip } = this.state;

    return (
      <div className="product-price-container">
        {showPriceAndRefLabels && (
          <div className="product-price-labels-wrapper">
            <div className="product-price-label">
              {priceLabel}
              <span className="with-tooltip" data-tooltip={priceTip}>
                <i className="zolaicon zolaicon-info" />
              </span>
            </div>
            <div className="product-ref-price-label">{refPriceLabel}</div>
          </div>
        )}
        <div className={`product-prices-wrapper ${isTile ? 'product-tile' : ''}`}>
          <div className={`product-price-wrapper ${!showPriceAndRefLabels ? 'product-price-center' : ''}`}>
            {showPriceLabel && !showRemaining && <span className="product-sale-label">Sale</span>}
            <span className="product-price">{this.priceRange(this.getPrice())}</span>
          </div>
          {showRefPrice && !showRemaining && (
            <div className={`product-ref-price-wrapper ${!showPriceAndRefLabels ? 'product-price-center' : ''}`}>
              <span className="product-ref-price-tile-wrapper">
                {showRefLabel && (
                  <span className="product-ref-label">List</span>
                )}
                <s className="small product-ref-price">
                  {this.priceRange(refPrice)}
                </s>
              </span>
              {showSaveAmount && (
                <span className="small product-ref-save">(Save: ${this.calcSaveAmount()})</span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

ProductPrice.propTypes = {
  sku: PropTypes.shape({
    price: PropTypes.number.isRequired,
    msrp: PropTypes.number
  }),
  look: PropTypes.shape({
    price: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired
    }).isRequired,
    msrp: PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired
    })
  }),
  isTile: PropTypes.bool,
  hidePriceLabels: PropTypes.bool,
  showRemaining: PropTypes.bool,
};

export default ProductPrice;



// WEBPACK FOOTER //
// ./src/components/product/ProductPrice.jsx